/**
 * Get content session from brightspot
 *
 */
import { gql } from '@apollo/client'
import { getIsLowBandwidth } from '../../hooks/useIsLowBandwidth'

export const expohallGQLQuery = () => {
  const imageSize = getIsLowBandwidth() ? 250 : 500
  return gql(`{
    OneOffPage(id: "/expohall") {
      content {
        ... on Promo {
          category
          description
        }
        ... on ListModule {
          ctaTarget
          title
          description
          items {
            title
            url
            contentUUID
            image {
              custom(height: ${imageSize}, width: ${imageSize}) {
                image {
                  src
                  }
                }
            }
            description
          }
          _style {
            _styledTemplate
          }
        }
      }
    }
}
  `)
}

export const dummy = () => {}
